import { render, staticRenderFns } from "./invoice-detail-header.vue?vue&type=template&id=b8628d72&scoped=true"
import script from "./invoice-detail-header.vue?vue&type=script&lang=js"
export * from "./invoice-detail-header.vue?vue&type=script&lang=js"
import style0 from "./invoice-detail-header.vue?vue&type=style&index=0&id=b8628d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8628d72",
  null
  
)

export default component.exports